import service from '@/services/SICUDgpd_per_crd';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener labels registrados en Integrity que serán utilizados en una vista.
     */
    async update({ dispatch, rootGetters }, event) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_per_crd: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_per_crd: [
              {
                doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
                crd_hij: event.step3.crd_hij,
                crd_per: event.step3.crd_per?.[0]?.lis_det_par || event.step3.crd_per,
                civ_est: event.step3.civ_est?.[0]?.civ__est || event.step3.civ_est,
                crd_dat_cab: event.step3.crd_dat_cab?.[0]?.lis_det_par || event.step3.crd_dat_cab,
              },
            ],
          },
        };

        let notification;

        service[event.method || 'post'](payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_per_crd;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_per_crd[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
